import React from 'react';
import AppText from '../../../../components/ui/typography/AppText/AppText';
import styles from './OrderConfirmOfferModal.module.scss';
import Html from '../../../../components/ui/components/Html/Html';

type Props = {}

const SenseBandInfoData: React.FC<Props> = () => {

   const [expanded, setExpanded] = React.useState(false);

   return (
      <div className={`${styles.rulesTextContainer} ${expanded && styles.rulesTextContainerExpanded}`}>
         <section>
            <h3>РОЗТЕРМІНУВАННЯ АБО ОПЛАТА ЧАСТИНАМИ НА BRONUI</h3>

            <h4>Маєте кредитну картку Sense Bank?</h4>
            <p>
               <AppText variant={'B400'}>
                  Оплатіть бронювання готельного номеру/апартаментів на сайті Bronui карткою
                  <strong> Sense Bank</strong>, а після оплати відкрийте <strong>Sense SuperApp </strong>
                  і розбийте суму на 3 місяці без переплат (за чинними умовами банку).
               </AppText>
            </p>

            {expanded && (
               <>
                  <ul>
                     <li>
                        <AppText variant={'B400'}>
                           <strong>Без переплат:</strong> 3 рівні щомісячні платежі без комісій з вашого боку.
                        </AppText>
                     </li>
                     <li><strong>Просто:</strong> спершу оплата на Bronui, далі — розтермінування цієї операції у
                        застосунку
                        Sense Bank.
                     </li>
                     <li><strong>Швидко:</strong> кілька кліків у телефоні — і все готово.</li>
                  </ul>

                  <p>
                     <strong>Важливо:</strong> Bronui не оформлює кредити і не має окремої інтеграції
                     розтермінування з Sense Bank. Ми виступаємо лише як банк еквайєр
                     (приймаємо вашу оплату). Усі умови розтермінування визначає Sense Bank
                     у своєму застосунку.
                  </p>

                  <h3>Як це зробити (крок за кроком)</h3>
                  <ol>
                     <li>Оберіть готельний номер/апартаменти та перейдіть до оплати на Bronui.</li>
                     <li>Сплатіть кредитною карткою Sense Bank.</li>
                     <li>
                        Відкрийте Sense SuperApp → знайдіть цю оплату → натисніть
                        «Оплата частинами / Розстрочка» → оберіть 3 місяці → підтвердьте.
                     </li>
                     <li>Готово. Платежі списуватимуться рівними частинами щомісяця.</li>
                  </ol>

                  <p><strong>Потрібен доступний кредитний ліміт на суму бронювання.</strong></p>

                  <h3>Інші банки</h3>
                  <p>
                     На боці Bronui немає окремої інтеграції «оплата частинами» з іншими банками.
                     Водночас у більшості банків є функція перевести вже здійснену покупку
                     в розстрочку у їхньому застосунку (умови встановлює ваш банк).
                  </p>

                  <ul>
                     <li>
                        <strong>monobank</strong> — розстрочка/«покупка частинами» в застосунку після оплати
                        (умови й комісії — за тарифами банку).
                     </li>
                     <li>
                        <strong>ПриватБанк</strong> — «миттєва розстрочка» після оплати
                        (умови й комісії — за тарифами банку).
                     </li>
                     <li>
                        <strong>А Банк, izibank та інші</strong> — подібні інструменти в застосунку банку
                        (умови й комісії — за тарифами банку).
                     </li>
                  </ul>

                  <p>
                     Якщо вам принципово без переплат — найпростіший спосіб зараз:
                     картка Sense Bank + розтермінування на 3 місяці після оплати у Sense SuperApp
                     (перевіряйте актуальні умови у банку).
                  </p>

                  <h3>Скасування та повернення</h3>
                  <ul>
                     <li>
                        Правила скасування залежать від обраного тарифу на Bronui
                        (повернення/неповернення).
                     </li>
                     <li>
                        Якщо оформлено повернення коштів, банк коригує розтермінування
                        за своїми правилами (терміни та спосіб зарахування визначає банк).
                     </li>
                  </ul>

                  <h3>Примітки</h3>
                  <p>Перевіряйте актуальні умови у Sense SuperApp або на сайті банку.</p>
                  <p>
                     Для інших банків доступність та вартість розстрочки визначаються умовами вашого банку.
                  </p>
               </>
            )}
         </section>

         {!expanded && <div className={styles.rulesTextContainerMask}>
            <AppText variant={'B400'}>
               <span className={styles.showMore} onClick={() => setExpanded(true)}>
                     Показати більше...
               </span>
            </AppText>
         </div>}

      </div>
   );
};

export default SenseBandInfoData;
